import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { agreementTones } from '../../../components/AnalysisLayout/analysis.utils';
import type { DimensionView } from '../interpretiveReportView';
import { DimensionIcon } from './DimensionIcon';
import { SectionHead } from './SectionHead';
import { Callout, ToneChip, toneClass } from './Tone';
import styles from '../InterpretiveReportPage.module.css';

const DimensionCard = ({ dimension }: { dimension: DimensionView }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(styles.dimensionCard, styles.keep)}>
      <div className={styles.cardTop}>
        <DimensionIcon dimension={dimension.key} />
        <ToneChip tone={dimension.status}>
          {t(`interpretiveReport.document.level.${dimension.status}`)}
        </ToneChip>
      </div>
      <h3 className={styles.dimensionName}>{dimension.name}</h3>
      <div className={styles.scoreBlock}>
        <span className={styles.dimensionScore}>{dimension.score}</span>
        <div aria-hidden="true" className={styles.bar}>
          <div
            className={cn(styles.barFill, toneClass(dimension.status, 'Fill'))}
            style={{ width: `${dimension.barPercent}%` }}
          />
        </div>
      </div>
      {dimension.key && (
        <p className={styles.description}>
          {t(`interpretiveReport.document.dimensionDescription.${dimension.key}`)}
        </p>
      )}
      <div className={styles.cardBottom}>
        <Callout
          tone={agreementTones[dimension.agreement]}
          lead={`${t(`teamResult.agreement.${dimension.agreement}`)}.`}
        >
          {t(`teamResult.agreementExplanation.${dimension.agreement}`)}
        </Callout>
      </div>
    </div>
  );
};

export const DimensionOverview = ({
  number,
  dimensions,
}: {
  number: string;
  dimensions: DimensionView[];
}) => {
  const { t } = useTranslation();
  return (
    <section>
      <SectionHead
        number={number}
        eyebrow={t('interpretiveReport.document.overview.eyebrow')}
        title={t('interpretiveReport.document.overview.title')}
        intro={t('interpretiveReport.document.overview.intro')}
      />
      <div className={styles.twoColumns}>
        {dimensions.map((dimension) => (
          <DimensionCard key={dimension.name} dimension={dimension} />
        ))}
      </div>
    </section>
  );
};
